/**
 * node modules
 */
require('slick-carousel');
require('remodal');
require('lazysizes');

/**
 * javascript files
 */
require('./video');
require('./standard-dropdown');
require('script!jquery');
foundation = require('foundation-sites');
moment = require('moment');
require('./products');
require('./faculty');
require('./form');
require('./table');
require('./navigation');
require('./brightCovePlayer');
require('./header');
require('./stickers');
require('./score');
require('./events');
require('./liveevent');
require('picturefill/dist/picturefill.min');
require('./lib/countdown');
require('./lib/helper');
require('./product-compare');
require('./product-configuration');
require('./modals');
require('./quiz');
require('./homepage');
require('./search');
require('./spotlight');
require('./lib/styleGuide');
require('./lib/pjax');
require('./error-page');
require('./lib/gtm-events');
//require('./lib/chat');
require('./product-filter');
require('./class');
require('./card');
require('./billboardVideo');
/**
 * css & sass files
 */
require('foundation-sites/dist/css/foundation-flex.min.css');
require('slick-carousel/slick/slick.css');
require('font-awesome/css/font-awesome.min.css');
require('../css/scss/style.scss');

require('jquery-ui/themes/base/theme.css');
require('jquery-ui/themes/base/base.css');

require('aos/dist/aos.css');


//lazy load images
document.addEventListener('lazybeforeunveil', function (e) {
	var bg = e.target.getAttribute('data-background-image'),
		head = document.head || document.getElementsByTagName('head')[0],
		style = document.createElement('style');

	style.type = 'text/css';
	if (style.styleSheet) {
		style.styleSheet.cssText = bg;
	} else {
		style.appendChild(document.createTextNode(bg));
	}
	head.appendChild(style);
});

$(window).load(function () {
	var newStyle = document.createElement('style');
	/*jshint multistr: true */
	newStyle.appendChild(document.createTextNode("\
    .fa {\
        opacity: 1 !important;\
    }\
    @font-face {\
        font-family:'FontAwesome';\
        src: local('fontawesome'), local('font awesome'), url('/dist/fontawesome-webfont.woff2') format('woff2');\
        font-weight: normal;\
        font-style: normal;\
        font-display: swap;\
    }\
    @import url('//hello.myfonts.net/count/39f9e7');\
    "));
	/*jshint multistr: false */
	document.head.appendChild(newStyle);
});

//adding pjax init function
document.addEventListener("latte:init", init);

//any where we have anchor a tag we do scroll animation
function init () {
	$('a').on('click', function (event) {
		if (/#/.test(this.href)) {
			if ($(this.hash).length >= 1) {
				event.preventDefault();
				$('html,body').animate({ scrollTop: $(this.hash).offset().top }, 600);
			}
		}
	});
}



//////////////////
// WEBPACK FOOTER
// ./public/js/index.js
// module id = 0
// module chunks = 0